<template>
  <div id="dashboard-content" v-if="content.data != null" v-loading="content.loading">
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item, index) in content.data.cards" :key="index">
        <div class="data-card purple">
          <div class="card-info">
            <div class="title">
              <span>{{ item.title }}</span>
            </div>
            <div class="value">
              <span>{{ item.value }}</span>
            </div>
            <div class="description">
              <span>{{ item.description }}</span>
            </div>
          </div>
          <div class="card-icon">
            <i :class="item.icon"></i>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="upgrade-overlay d-none">
            <h3>{{ $t("components.dashboard.content.cantAccess") }}</h3>
            <p>{{ $t("components.dashboard.content.cantAccessMsg") }}</p>
            <el-button size="medium" type="primary" round>{{ $t("components.dashboard.content.upgrade") }}</el-button>
          </div>

          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.content.posts") }}</h3>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport(7)"></el-button>
            </el-tooltip>
          </div>

          <el-table :data="content.data.postStatistics" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.content.postType')" min-width="180">
              <template slot-scope="scope">
                <span></span>
                  <b>{{ scope.row.title }}</b>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.content.sharing')" width="100">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.count }}</b>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.content.comment')" width="100">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.commentCount }}</b>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.content.like')" width="100">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.likeCount }}</b>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.content.sessionReview") }}</h3>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport(15)"></el-button>
            </el-tooltip>
          </div>

          <el-table :data="content.data.eventProgramStatistics.slice(0, programArraySlicer)" style="width: 100%">
            <el-table-column label="" width="60">
              <template slot-scope="scope">
                <div class="program-shorting">
                  <span>#{{ scope.$index + 1 }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.program')" min-width="180">
              <template slot-scope="scope">
                <span class="program-title" @click="handleOpen(scope.row.id)">
                  <b>{{ scope.row.title }}</b>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.average')" width="110">
              <template slot-scope="scope">
                <span class="program-avg-rate">
                  <i class="fas fa-star"></i>
                  <b>{{ scope.row.avgRate == null ? "0" : scope.row.avgRate.toFixed(2) }}</b>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.review')" width="110">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.rateCount }}</b>
                  {{ $t("components.dashboard.content.review") }}
                </span>
              </template>
            </el-table-column>
          </el-table>

          <div class="show-all" v-if="content.data.eventProgramStatistics.length > 10">
            <el-button size="mini" @click="showAllReviews()" round>{{ programArraySlicer > 10 ? $t("components.dashboard.content.seeLess") : $t("components.dashboard.content.seeAll") }}</el-button>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.content.contents") }}</h3>
          
          </div>

          <el-table :data="content.data.contentStatistics" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.speakers')" min-width="180"></el-table-column>
            <el-table-column prop="count" :label="$t('components.dashboard.content.content')" width="70"></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.content.networkingRooms") }}</h3>
          
          </div>

          <el-table :data="content.data.networkingAreaStatistics.slice(0, networkingArraySlicer)" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.room')" min-width="180">
              <template slot-scope="scope">
                <span style="display:block;">
                  <b>{{ scope.row.title }}</b>
                </span>
                <!-- <span>{{ scope.row.description }}</span> -->
              </template>
            </el-table-column>
       
          </el-table>

          <div class="show-all" v-if="content.data.networkingAreaStatistics.length > 5">
            <el-button size="mini" @click="showAllRooms()" round>{{ networkingArraySlicer > 5 ? $t("components.dashboard.content.seeLess") : $t("components.dashboard.content.seeAll") }}</el-button>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.content.subActivity") }}</h3>
          
          </div>

          <el-table :data="content.data.subEventStatistics" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.subEvent')" min-width="180">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.title }}</b>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="title" :label="$t('components.dashboard.content.total')" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.content.productActivity") }}</h3>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport(21)"></el-button>
            </el-tooltip>
          </div>

          <el-table :data="content.data.additionalProductStatistics" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.product')" min-width="180">
              <template slot-scope="scope">
                <span
                  ><b>{{ scope.row.title }}</b></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.confirmation')" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.approved }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.waiting')" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.pending }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.rejection')" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.cancelled }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('components.dashboard.content.total')" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
export default {
  components: {},
  name: "Content",
  data() {
    return {
      programArraySlicer: 10,
      networkingArraySlicer: 5
    };
  },
  methods: {
    downloadReport(type) {
      if (type == null || type == undefined) {
        return;
      } else {
        this.exportXlsx(type, null, null);
      }
      // axios.post("report/generalstatistics", {}).then(res => {
      //   this.$message.success(res.data.alert.message)
      // })
    },
    showAllReviews() {
      if (this.programArraySlicer == 10) {
        this.programArraySlicer = 999999;
      } else if (this.programArraySlicer == 999999) {
        this.programArraySlicer = 10;
      }
    },
    showAllRooms() {
      if (this.networkingArraySlicer == 5) {
        this.networkingArraySlicer = 999999;
      } else if (this.networkingArraySlicer == 999999) {
        this.networkingArraySlicer = 5;
      }
    }
  },

  async mounted() {
    if (this.content.data == null) {
      await this.$store.dispatch("getContent", {});
    }
  },

  computed: {
    content() {
      return this.$store.getters.getDashboardContent;
    }
  },

  beforeDestroy() {},

  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Content.vue